module.exports = __webpack_public_path__ + "static/media/bedok.887170de.png";